import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconCircleRightOutlined = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
            <g id="icon-circle-right-outlined" fill={color}>
                <path d="M10.5095 8.55579C10.7958 8.26947 10.7958 7.74737 10.5095 7.46105L7.47789 4.42947C7.17474 4.12632 6.68632 4.12632 6.38316 4.42947C6.08 4.73263 6.08 5.22105 6.38316 5.52421L8.85895 8L6.38316 10.4758C6.23158 10.6274 6.14737 10.8295 6.14737 11.0316C6.14737 11.2337 6.23158 11.4358 6.38316 11.5874C6.68632 11.8905 7.17474 11.8905 7.4779 11.5874L10.5095 8.55579Z" fill={color}/>
                <path d="M16 8C16 3.58737 12.4126 -1.22803e-06 8 -1.03514e-06C3.58737 -8.42262e-07 -5.42573e-07 3.58737 -3.49691e-07 8C-1.56809e-07 12.4126 3.58737 16 8 16C12.4126 16 16 12.4126 16 8ZM1.54947 8C1.54947 4.44632 4.44632 1.54947 8 1.54947C11.5537 1.54947 14.4505 4.44631 14.4505 8C14.4505 11.5537 11.5537 14.4505 8 14.4505C4.44632 14.4505 1.54947 11.5537 1.54947 8Z" fill={color}/>
            </g>
        </svg>
    </div>
);

export default IconCircleRightOutlined;
